<template>
  <div>
    <div class="row mb-3 pe-4">
      <div class="col-lg-8 col-md-6 col-6 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-2">KIOSK GENERAL SETTING</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-6 d-flex justify-content-end">
        <!-- KSK063: the Appearance tab saves through its own button. -->
        <material-button
          v-if="!isAppearance"
          @click="updateKioskSettings()"
          class="btn-background btn-sm"
        >
          {{ $t("Save") }}
        </material-button>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100">
      <div class="c-container">
        <div class="row">
          <div
            class="col-lg-12 col-md-12 col-12 mx-auto pb-5 mt-2"
            v-if="isLoadData"
          >
            <div class="card-body" style="padding: 0rem 0rem">
              <div class="row d-flex">
                <div class="tab-list p-0">
                  <ul id="general-tab" class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        id="nav_item_1"
                        class="nav-link active"
                        @click="changeTab(1)"
                      >
                        {{ $t("Options") }}
                      </a>
                    </li>
                    <li class="nav-item">
                      <a id="nav_item_2" class="nav-link" @click="changeTab(2)">
                        Payment Mode
                      </a>
                    </li>
                    <li class="nav-item">
                      <a id="nav_item_3" class="nav-link" @click="changeTab(3)">
                        {{ $t("Kiosk_Appearance") }}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="row card-custom-new mt-3">
                  <div class="col-12" v-if="isOptions">
                    <div class="row">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Sale Channel
                      </div>
                      <div
                        class="col-lg-4 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <Multiselect
                          :searchable="true"
                          v-model="form.branch_id"
                          :options="branchs"
                          :canClear="false"
                          @change="changeBranch"
                        />
                      </div>
                      <div
                        class="col-lg-4 col-12">
                        <a v-if="moo_order_url" :href="moo_order_url + '/kiosk'" target="_blank" class="text-primary">Go to Ordering Kiosk</a>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Operation Mode
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <Multiselect
                          :searchable="true"
                          v-model="form.operation_mode"
                          :options="operation_modes"
                          :canClear="false"
                        />
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Enable Dine-in/Take Away Option
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{ active: isActiveDiningOption }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_dining_option"
                            v-on:change="triggerEventDiningOption"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mt-3"
                      v-if="isActiveDiningOption && form.branch_id"
                    >
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Dining Location
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <Multiselect
                          :searchable="true"
                          v-model="form.dining_location"
                          :options="dining_locations"
                          :canClear="false"
                        />
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Takeaway Indicator
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <Multiselect
                          :searchable="true"
                          v-model="form.takeaway_indicator"
                          :options="takeaway_indicator_types"
                          :canClear="false"
                        />
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Show Buzzer Number (Dine In)
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{ active: isActiveBuzzerNumberDineIn }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_buzzer_number_dine_in"
                            v-on:change="triggerEventBuzzerNumberDineIn"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Show Buzzer Number (Takeaway)
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{ active: isActiveBuzzerNumberTakeaway }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_buzzer_number_takeaway"
                            v-on:change="triggerEventBuzzerNumberTakeaway"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id && (isActiveBuzzerNumberDineIn || isActiveBuzzerNumberTakeaway)">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Buzzer Number Text
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          class="col-lg-8 col-12"
                          style="align-items: center; gap: 30px; max-width: 500px;"
                        >
                          <material-input
                            v-model="form.buzzer_number_text"
                            extraClass="ml-5"
                            placeholder="Enter buzzer number text"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Enable Retail Mode
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{ active: isActiveEnableRetailMode }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_enable_retail_mode"
                            v-on:change="triggerEventEnableRetailMode"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mt-3"
                      v-if="isActiveEnableRetailMode && form.branch_id"
                    >
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Minty Staff on Retail Mode
                      </div>
                      <div
                        class="col-lg-8 col-12 d-flex align-items-center"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{ active: isActiveStaffOnRetailMode }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_staff_on_retail_mode"
                            v-on:change="triggerEventStaffOnRetailMode"
                            class="mb-0"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mt-3"
                      v-if="isActiveEnableRetailMode && form.branch_id"
                    >
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Spending Limit / Month
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <material-input
                          v-model="form.spending_limit"
                          extraClass="ml-5"
                          placeholder="Enter spending limit / month"
                          type="number"
                          :disabled="!isActiveStaffOnRetailMode"
                        />
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Pin Code
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          class="col-lg-8 col-12"
                          style="align-items: center; gap: 30px; max-width: 500px;"
                        >
                          <material-input
                            v-model="form.kiosk_pin_code"
                            extraClass="ml-5"
                            placeholder="Enter pin code"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Minty membership on kiosk
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{ active: isActiveMintyMembershipOnKiosk }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_minty_membership_on_kiosk"
                            v-on:change="triggerEventMintyMembershipOnKiosk"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Require passcode entry to redeem vouchers
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{
                            active: isActiveRequirePasscodeEntryToRedeemVouchers,
                          }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_require_passcode_entry_to_redeem_vouchers"
                            v-on:change="
                              triggerEventRequirePasscodeEntryToRedeemVouchers
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Display all MOG's description
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{ active: isActiveShowMogDescriptionOnKiosk }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_show_mog_description_on_kiosk"
                            v-on:change="triggerEventShowMogDescriptionOnKiosk"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Display all item price next to name in cart
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{
                            active: isActiveShowItemPriceInCartOnKiosk,
                          }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_show_item_price_in_cart_on_kiosk"
                            v-on:change="triggerEventShowItemPriceInCartOnKiosk"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-4 col-12 label-form d-flex align-items-center"
                      >
                        Display edit button on item in cart
                      </div>
                      <div
                        class="col-lg-8 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <div
                          :class="{
                            active: isActiveShowEditItemBtnInCartOnKiosk,
                          }"
                          class="toggle_container"
                        >
                          <MaterialToggleButton
                            labelEnableText=""
                            labelDisableText=""
                            id="event_handle_show_edit_item_btn_in_cart_on_kiosk"
                            v-on:change="
                              triggerEventShowEditItemBtnInCartOnKiosk
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12" v-if="isAppearance">
                    <KioskAppearance
                      :branchs="branchs"
                      :branch-id="form.branch_id"
                      :moo-order-url="moo_order_url"
                      :saved-colors="kioskCustomColors"
                      @change-branch="changeBranch"
                      @saved="kioskCustomColors = $event"
                      @notify="showNotify"
                    />
                  </div>
                  <div class="col-lg-12 col-md-12 col-12" v-if="isPaymentMode">
                    <div class="row">
                      <div
                        class="col-lg-2 col-12 label-form d-flex align-items-center"
                      >
                        Sale Channel
                      </div>
                      <div
                        class="col-lg-6 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <Multiselect
                          :searchable="true"
                          v-model="form.branch_id"
                          :options="branchs"
                          :canClear="false"
                          @change="changeBranch"
                        />
                      </div>
                      <div
                        class="col-lg-4 col-12">
                        <a v-if="moo_order_url" :href="moo_order_url + '/kiosk'" target="_blank" class="text-primary">Go to Ordering Kiosk</a>
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id">
                      <div
                        class="col-lg-2 col-12 label-form d-flex align-items-center"
                      >
                        Payment Mode
                      </div>
                      <div
                        class="col-lg-10 col-12"
                        style="align-items: center; gap: 30px"
                      >
                        <Multiselect
                          :searchable="true"
                          v-model="form.payment_mode"
                          :options="payment_modes"
                          :canClear="false"
                        />
                      </div>
                    </div>
                    <div class="row mt-3" v-if="form.branch_id && (form.payment_mode == STRIPE || form.payment_mode == AIRWALLEX)">
                      <div
                        class="col-lg-2 col-12 label-form d-flex align-items-center"
                      >
                        Terminal ID
                      </div>
                      <div
                        class="col-lg-10 col-12"
                        style="align-items: center; gap: 30px; max-width: 500px;"
                      >
                        <material-input
                          v-if="form.payment_mode == AIRWALLEX"
                          v-model="form.airwallex_terminal_id"
                          extraClass="ml-5"
                          placeholder="Enter terminal id"
                          type="text"
                        />
                        <material-input
                          v-else
                          v-model="form.terminal_id"
                          extraClass="ml-5"
                          placeholder="Enter terminal id"
                          type="text"
                        />
                      </div>
                    </div>
                    <div v-if="form.branch_id && form.payment_mode == 2">
                      
                      <div class="row mt-3" >
                        <div
                          class="col-lg-2 col-12 label-form d-flex align-items-center"
                        >
                          Cashier Station Number
                        </div>
                        <div
                          class="col-lg-10 col-12"
                          style="align-items: center; gap: 30px; max-width: 500px;"
                        >
                          <material-input
                            v-model="form.cashier_no"
                            extraClass="ml-5"
                            placeholder="Enter cashier station number"
                            type="text"
                          />
                        </div>
                      </div>
                      <div class="row mt-3" >
                        <div
                          class="col-lg-2 col-12 label-form d-flex align-items-center"
                        >
                          Operator Number
                        </div>
                        <div
                          class="col-lg-10 col-12"
                          style="align-items: center; gap: 30px; max-width: 500px;"
                        >
                          <material-input
                            v-model="form.oper_no"
                            extraClass="ml-5"
                            placeholder="Enter operator number"
                            type="text"
                          />
                        </div>
                      </div>
                      <div class="row mt-3" >
                        <div
                          class="col-lg-2 col-12 label-form d-flex align-items-center"
                        >
                          Terminal Serial Number
                        </div>
                        <div
                          class="col-lg-10 col-12"
                          style="align-items: center; gap: 30px; max-width: 500px;"
                        >
                          <material-input
                            v-model="form.terminal_serial_number"
                            extraClass="ml-5"
                            placeholder="Enter terminal serial number"
                            type="text"
                          />
                        </div>
                      </div>
                      <div class="row mt-3" >
                        <div
                          class="col-lg-2 col-12 label-form d-flex align-items-center"
                        >
                          Terminal No
                        </div>
                        <div
                          class="col-lg-10 col-12"
                          style="align-items: center; gap: 30px; max-width: 500px;"
                        >
                          <material-input
                            v-model="form.terminal_no"
                            extraClass="ml-5"
                            placeholder="Enter terminal id"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="form.branch_id && form.payment_mode">
                      <div
                        class="col-lg-2 col-12 label-form d-flex align-items-center"
                      >
                      </div>
                      <div class="col-lg-10 col-12" style="max-width: 700px">
                        <div class="row mt-3 mb-1 align-items-center">
                          <div class="col-6" style="color: #7b809a; font-weight: 500">
                            Type
                          </div>
                          <div class="col-6" style="color: #7b809a; font-weight: 500">
                            Name
                          </div>
                        </div>
                        <div class="row align-items-center">
                          <div class="col-6 d-flex align-items-center label-form">
                            <material-checkbox
                              @change="changeAllowPayNow(form.allow_paynow)"
                              v-model="form.allow_paynow"
                              :checked="form.allow_paynow"
                              name="paynow"
                              class="align-items-center px-3"
                            ></material-checkbox>
                            PayNow
                          </div>
                          <div class="col-6">
                            <material-input
                              v-if="form.allow_paynow"
                              v-model="form.payment_method_mappings.paynow"
                              :placeholder="paymentMethodPlaceholder('paynow')"
                              type="text"
                            />
                          </div>
                        </div>
                        <div class="row align-items-center">
                          <div class="col-6 d-flex align-items-center label-form">
                            <material-checkbox
                              @change="
                                changeAllowCreditCard(form.allow_creditcard)
                              "
                              v-model="form.allow_creditcard"
                              :checked="form.allow_creditcard"
                              name="creditcard"
                              class="align-items-center px-3"
                            ></material-checkbox>
                            Credit Card
                          </div>
                          <div class="col-6">
                            <material-input
                              v-if="form.allow_creditcard"
                              v-model="form.payment_method_mappings.credit_card"
                              :placeholder="paymentMethodPlaceholder('credit_card')"
                              type="text"
                            />
                          </div>
                        </div>
                        <div class="row align-items-center">
                          <div class="col-6 d-flex align-items-center label-form">
                            <material-checkbox
                              @change="
                                changeAllowShopback(form.allow_shopback)
                              "
                              v-model="form.allow_shopback"
                              :checked="form.allow_shopback"
                              name="shopback"
                              class="align-items-center px-3"
                            ></material-checkbox>
                            ShopBack Pay
                          </div>
                          <div class="col-6">
                            <material-input
                              v-if="form.allow_shopback"
                              v-model="form.payment_method_mappings.shopback"
                              :placeholder="paymentMethodPlaceholder('shopback')"
                              type="text"
                            />
                          </div>
                        </div>
                        <div class="row align-items-center">
                          <div class="col-6 d-flex align-items-center label-form">
                            <material-checkbox
                              @change="
                                changeAllowPaymentByMintyWallet(form.allow_ewallet)
                              "
                              v-model="form.allow_ewallet"
                              :checked="form.allow_ewallet"
                              name="payment_by_minty_wallet"
                              class="align-items-center px-3"
                            ></material-checkbox>
                            Payment by Minty Wallet
                          </div>
                          <div class="col-6">
                            <material-input
                              v-if="form.allow_ewallet"
                              v-model="inheritedPaymentMethodMappings.minty_wallet"
                              :placeholder="paymentMethodPlaceholder('minty_wallet')"
                              :readOnly="true"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-fixed top-1 end-1 z-index-2 message-success">
          <material-snackbar
            v-if="snackbar === 'danger' || snackbar === 'success'"
            title=""
            date=""
            :description="message"
            :icon="{ component: 'campaign', color: 'white' }"
            :color="snackbar"
            :close-handler="closeSnackbar"
          />
        </div>
        <material-loading :active="loaderActive" />
      </div>
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import TestService from "../../../services/test.service";
import SettingStoreService from "../../../services/settingStore.service";
import SettingGeneralService from "../../../services/settingGeneral.service";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialToggleButton from "@/components/MaterialToggleButton.vue";
import KioskAppearance from "./KioskAppearance.vue";

// Payment Method Mapping. A box opens on the name this branch reports - its own where it has one,
// otherwise the merchant-wide name from Setting -> General, otherwise the default - so no branch
// ever shows an empty box. Clearing a box drops this branch's row and goes back to inheriting,
// which is what the placeholder then shows.
const BLANK_PAYMENT_METHOD_MAPPINGS = {
  paynow: "",
  credit_card: "",
  shopback: "",
  minty_wallet: "",
};

// What a method is called until someone names it - the same list the API falls back to, in
// MintyPaymentMethodMapping::DEFAULT_NAMES. A card is "Online" and so is a PayNow, whichever
// provider took it: the provider changes the reader, not the tender POS files the money under.
// Only reached before a branch is picked, or where the API answers nothing for a method.
const SUGGESTED_PAYMENT_METHOD_NAMES = {
  paynow: "Online",
  credit_card: "Online",
  shopback: "Shopback",
  minty_wallet: "eWallet",
};

export default {
  name: "KioskGeneral",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Multiselect,
    MaterialInput,
    MaterialCheckbox,
    MaterialToggleButton,
    KioskAppearance,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      isLoadData: true,
      type: 1,
      isOptions: false,
      isPaymentMode: false,
      isAppearance: false,
      // KSK063: the branch's saved per-element kiosk colours.
      kioskCustomColors: null,
      form: {
        branch_id: 0,
        terminal_type: 1,
        terminal_id: "",
        ariwallex_terminal_id: "",
        cashier_no: "",
        oper_no: "",
        terminal_serial_number: "",
        terminal_no: "",
        payment_mode: 0,
        allow_paynow: 0,
        allow_creditcard: 0,
        allow_shopback: 0,
        allow_ewallet: 0,
        // Payment Method Mapping: the POS tender name reported for each ticked payment method,
        // per branch. Saved as its own rows on the API side, not as branch columns.
        payment_method_mappings: { ...BLANK_PAYMENT_METHOD_MAPPINGS },
        operation_mode: 1,
        dining_option: 0,
        buzzer_number_dine_in: 0,
        buzzer_number_takeaway: 0,
        buzzer_number_text: "",
        dining_location: 1,
        takeaway_indicator: 2,
        enable_retail_mode: 0,
        staff_on_retail_mode: 0,
        spending_limit: 0,
        kiosk_pin_code: "",
        membership_on_kiosk: 0,
        require_passcode_entry_to_redeem_vouchers: 0,
        show_mog_description_on_kiosk: 0,
        show_item_price_in_cart_on_kiosk: 1,
        show_edit_item_btn_in_cart_on_kiosk: 1,
      },
      // What each blank Payment Method Mapping box resolves to: the merchant-wide name from
      // Setting -> General, or '' where nobody named the method. Placeholder only; never sent back.
      inheritedPaymentMethodMappings: {},
      branchs: [],
      isActiveDiningOption: false,
      isActiveBuzzerNumberDineIn: false,
      isActiveBuzzerNumberTakeaway: false,
      isActiveEnableRetailMode: false,
      isActiveStaffOnRetailMode: false,
      isActiveMintyMembershipOnKiosk: false,
      isActiveRequirePasscodeEntryToRedeemVouchers: false,
      isActiveShowMogDescriptionOnKiosk: false,
      isActiveShowItemPriceInCartOnKiosk: true,
      isActiveShowEditItemBtnInCartOnKiosk: true,
      operation_modes: [
        { value: 1, label: "Test" },
        { value: 2, label: "Live" },
      ],
      dining_locations: [
        { value: 0, label: "Both" },
        { value: 1, label: "Takeaway" },
        { value: 2, label: "Dine In" },
      ],
      payment_modes: [
        { value: 1, label: "Stripe" },
        { value: 2, label: "AllInPay" },
        { value: 3, label: "Airwallex" },
      ],
      takeaway_indicator_types: [
        { value: 1, label: "As a Modifier for every item" },
        { value: 2, label: "As a Staff Name" },
      ],
      moo_order_url: "",
      STRIPE: 1,
      ALLINPAY: 2,
      AIRWALLEX: 3,
    };
  },
  created() {
    this.changeTab(this.type);
    this.getBranches();
  },
  mounted() {},
  methods: {
    resetTabs() {
      this.isOptions = false;
      this.isPaymentMode = false;
      this.isAppearance = false;
    },

    changeTab(type) {
      this.resetTabs();
      $("#general-tab .nav-link").removeClass("active");
      $("#nav_item_" + type).addClass("active");
      if (type == 1) {
        this.isOptions = true;
      } else if (type == 2) {
        this.isPaymentMode = true;
      } else if (type == 3) {
        this.isAppearance = true;
      }
    },

    /**
     * What a blank Payment Method Mapping box says: the merchant-wide name it would inherit, or
     * the suggested name where the merchant has not named the method either. A suggestion is text
     * on a screen - it is never saved and never reaches POS.
     */
    paymentMethodPlaceholder(method) {
      return (
        this.inheritedPaymentMethodMappings[method] ||
        SUGGESTED_PAYMENT_METHOD_NAMES[method]
      );
    },

    changeBranch(id) {
      this.form.branch_id = id;
      this.showLoader();
      SettingStoreService.getDataBranchDetail(id).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const branch = response.data.data.branch;
            this.moo_order_url = branch.moo_order_url;
            this.kioskCustomColors = branch.kiosk_custom_colors || null;
            this.form.terminal_type = branch.terminal_type;
            this.form.terminal_id = branch.terminal_id;
            this.form.airwallex_terminal_id = branch.airwallex_terminal_id;
            this.form.cashier_no = branch.cashier_no;
            this.form.oper_no = branch.oper_no;
            this.form.terminal_serial_number = branch.terminal_serial_number;
            this.form.terminal_no = branch.terminal_no;
            this.form.payment_mode = branch.payment_mode;
            this.form.allow_paynow = branch.allow_paynow;
            this.form.allow_creditcard = branch.allow_creditcard;
            this.form.allow_shopback = branch.allow_shopback;
            this.form.allow_ewallet = branch.allow_ewallet;
            // The resolved names, not this branch's own rows: a branch that has named nothing
            // still opens on the name it reports - the merchant's, or the default - rather than on
            // an empty box. Saving keeps what is shown, so the branch ends up owning the name it
            // was already reporting; clearing a box still drops the row and goes back to
            // inheriting.
            this.inheritedPaymentMethodMappings = branch.payment_method_mappings_inherited || {};
            this.form.payment_method_mappings = {
              ...BLANK_PAYMENT_METHOD_MAPPINGS,
              ...this.inheritedPaymentMethodMappings,
              ...(branch.payment_method_mappings || {}),
            };
            this.form.operation_mode = branch.operation_mode;
            this.form.dining_option = branch.show_dining_option;
            this.isActiveDiningOption =
              branch.show_dining_option == 1 ? true : false;
            this.form.buzzer_number_dine_in = branch.show_buzzer_number_dine_in;
            this.isActiveBuzzerNumberDineIn =
              branch.show_buzzer_number_dine_in == 1 ? true : false;
            this.form.buzzer_number_takeaway = branch.show_buzzer_number_takeaway;
            this.isActiveBuzzerNumberTakeaway =
              branch.show_buzzer_number_takeaway == 1 ? true : false;
            this.form.buzzer_number_text = branch.buzzer_number_text;
            this.form.dining_location = branch.dining_location;
            this.form.enable_retail_mode = branch.enable_retail_mode;
            this.isActiveEnableRetailMode =
              branch.enable_retail_mode == 1 ? true : false;
            this.isActiveStaffOnRetailMode =
              branch.staff_on_retail_mode == 1 ? true : false;
            this.form.staff_on_retail_mode = branch.staff_on_retail_mode;
            this.form.spending_limit = branch.spending_limit;
            this.form.membership_on_kiosk = branch.membership_on_kiosk;
            this.isActiveMintyMembershipOnKiosk =
              branch.membership_on_kiosk == 1 ? true : false;
            this.form.require_passcode_entry_to_redeem_vouchers = branch.require_passcode_entry_to_redeem_vouchers;
            this.isActiveRequirePasscodeEntryToRedeemVouchers =
              branch.require_passcode_entry_to_redeem_vouchers == 1
                ? true
                : false;
            this.form.kiosk_pin_code = branch.kiosk_pin_code;
            this.form.takeaway_indicator = branch.takeaway_indicator;
            this.form.show_mog_description_on_kiosk =
              branch.show_mog_description_on_kiosk;
            this.isActiveShowMogDescriptionOnKiosk =
              branch.show_mog_description_on_kiosk == 1 ? true : false;
            this.form.show_item_price_in_cart_on_kiosk =
              branch.show_item_price_in_cart_on_kiosk;
            this.isActiveShowItemPriceInCartOnKiosk =
              branch.show_item_price_in_cart_on_kiosk == 1 ? true : false;
            this.form.show_edit_item_btn_in_cart_on_kiosk =
              branch.show_edit_item_btn_in_cart_on_kiosk;
            this.isActiveShowEditItemBtnInCartOnKiosk =
              branch.show_edit_item_btn_in_cart_on_kiosk == 1 ? true : false;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    getBranches() {
      this.isLoadData = false;
      this.showLoader();
      TestService.getBranches().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branchs = response.data.data;
            this.isLoadData = true;
            if (this.branchs.length > 0) {
              this.changeBranch(this.branchs[0].value);
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    updateKioskSettings() {
      this.showLoader();
      SettingGeneralService.updateKioskSettings(this.form).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Save success";
            this.setTimeOutNotification();
            // Re-read the branch: what a blank Payment Method Mapping box now inherits is only
            // known on the API side. Clearing a box drops the branch's row, and its placeholder
            // has to say the merchant-wide name it fell back to instead of the name just deleted.
            if (this.form.branch_id) {
              this.changeBranch(this.form.branch_id);
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    triggerEventDiningOption(value) {
      if (typeof value == "boolean") {
        this.isActiveDiningOption = !this.isActiveDiningOption;
        this.form.dining_option = this.isActiveDiningOption ? 1 : 0;
      }
    },

    triggerEventBuzzerNumberDineIn(value) {
      if (typeof value == "boolean") {
        this.isActiveBuzzerNumberDineIn = !this.isActiveBuzzerNumberDineIn;
        this.form.buzzer_number_dine_in = this.isActiveBuzzerNumberDineIn ? 1 : 0;
      }
    },

    triggerEventBuzzerNumberTakeaway(value) {
      if (typeof value == "boolean") {
        this.isActiveBuzzerNumberTakeaway = !this.isActiveBuzzerNumberTakeaway;
        this.form.buzzer_number_takeaway = this.isActiveBuzzerNumberTakeaway
          ? 1
          : 0;
      }
    },

    changeAllowPayNow(value = 0) {
      if (typeof value == "boolean") {
        this.form.allow_paynow = value ? 1 : 0;
      }
    },

    changeAllowCreditCard(value = 0) {
      if (typeof value == "boolean") {
        this.form.allow_creditcard = value ? 1 : 0;
      }
    },

    changeAllowShopback(value = 0) {
      if (typeof value == "boolean") {
        this.form.allow_shopback = value ? 1 : 0;
      }
    },

    changeAllowPaymentByMintyWallet(value = 0) {
      if (typeof value == "boolean") {
        this.form.allow_ewallet = value ? 1 : 0;
      }
    },

    triggerEventEnableRetailMode(value) {
      if (typeof value == "boolean") {
        this.isActiveEnableRetailMode = !this.isActiveEnableRetailMode;
        this.form.enable_retail_mode = this.isActiveEnableRetailMode ? 1 : 0;
      }
    },

    triggerEventStaffOnRetailMode(value) {
      if (typeof value == "boolean") {
        this.isActiveStaffOnRetailMode = !this.isActiveStaffOnRetailMode;
        this.form.staff_on_retail_mode = this.isActiveStaffOnRetailMode ? 1 : 0;
      }
    },

    triggerEventMintyMembershipOnKiosk(value) {
      if (typeof value == "boolean") {
        this.isActiveMintyMembershipOnKiosk = !this
          .isActiveMintyMembershipOnKiosk;
        this.form.membership_on_kiosk = this.isActiveMintyMembershipOnKiosk
          ? 1
          : 0;
      }
    },

    triggerEventRequirePasscodeEntryToRedeemVouchers(value) {
      if (typeof value == "boolean") {
        this.isActiveRequirePasscodeEntryToRedeemVouchers = !this
          .isActiveRequirePasscodeEntryToRedeemVouchers;
        this.form.require_passcode_entry_to_redeem_vouchers = this
          .isActiveRequirePasscodeEntryToRedeemVouchers
          ? 1
          : 0;
      }
    },

    triggerEventShowMogDescriptionOnKiosk(value) {
      if (typeof value == "boolean") {
        this.isActiveShowMogDescriptionOnKiosk = !this
          .isActiveShowMogDescriptionOnKiosk;
        this.form.show_mog_description_on_kiosk = this
          .isActiveShowMogDescriptionOnKiosk
          ? 1
          : 0;
      }
    },

    triggerEventShowItemPriceInCartOnKiosk(value) {
      if (typeof value == "boolean") {
        this.isActiveShowItemPriceInCartOnKiosk = !this
          .isActiveShowItemPriceInCartOnKiosk;
        this.form.show_item_price_in_cart_on_kiosk = this
          .isActiveShowItemPriceInCartOnKiosk
          ? 1
          : 0;
      }
    },

    triggerEventShowEditItemBtnInCartOnKiosk(value) {
      if (typeof value == "boolean") {
        this.isActiveShowEditItemBtnInCartOnKiosk = !this
          .isActiveShowEditItemBtnInCartOnKiosk;
        this.form.show_edit_item_btn_in_cart_on_kiosk = this
          .isActiveShowEditItemBtnInCartOnKiosk
          ? 1
          : 0;
      }
    },

    showNotify(type, message) {
      this.snackbar = type;
      this.message = message;
      this.setTimeOutNotification();
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>

<style scoped>
.c-container {
  width: 100%;
  max-width: 100%;
  padding-left: 25px;
  padding-right: 25px;
}

.text-back {
  color: black !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.tab-list {
  overflow-x: auto;
  padding-bottom: 5px !important;
}

.tab-list::-webkit-scrollbar {
  height: 7px;
}

.tab-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.tab-list::-webkit-scrollbar-thumb {
  background: #888;
}

.tab-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.tab-list #general-tab {
  flex-wrap: unset !important;
}

.tab-list #general-tab li.nav-item {
  min-width: fit-content;
}

#preview img {
  max-width: 80px;
  max-height: 80px;
}

@media only screen and (max-width: 600px) {
  .wrap-card .card-item:last-child {
    margin-bottom: 80px !important;
  }

  .toggle-switch-custom {
    padding-top: 5px;
  }
}

.multiselect {
  max-width: 500px !important;
  margin-left: 0;
}
</style>
